import React, { useState, useRef } from 'react';
const testimonials = [{
  stars: 5,
  text: '"From 4 night wakings to none in 12 days. As a company director, I needed a system, not advice. B.A.B.Y. 365 gave me back my nights and my productivity."',
  initials: 'JM',
  name: 'Jennifer M.',
  location: 'Austin, Texas'
}, {
  stars: 5,
  text: '"The visual stimulation section is incredible. My pediatrician can\'t believe the coordination Liam has at 5 months. The protocol works exactly as promised."',
  initials: 'DW',
  name: 'David W.',
  location: 'Denver, Colorado'
}, {
  stars: 5,
  text: '"The only protocol my husband and I applied together without conflict. It saved our couple\'s communication and the whole family\'s sleep. Worth 10 times what it costs."',
  initials: 'SK',
  name: 'Sarah K.',
  location: 'Charlotte, North Carolina'
}];
interface VideoCardProps {
  src: string;
  quote: string;
}
function VideoCard({
  src,
  quote
}: VideoCardProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [hasUnmuted, setHasUnmuted] = useState(false);
  const playCountRef = useRef(0);
  const handleToggleSound = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !video.muted;
    setIsMuted(video.muted);
    if (!video.muted) {
      setHasUnmuted(true);
      playCountRef.current = 0;
      video.currentTime = 0;
      video.play();
    }
  };
  const handleVideoEnded = () => {
    const video = videoRef.current;
    if (!video) return;
    if (hasUnmuted && !video.muted) {
      video.muted = true;
      setIsMuted(true);
      setHasUnmuted(false);
    }
    video.play();
  };
  return <div id="testimonials" className="rounded-3xl overflow-hidden bg-white shadow-lg border border-[rgba(183,110,121,0.15)]" data-id="element-264">
      <div className="relative w-full cursor-pointer" style={{
      aspectRatio: '9/16'
    }} onClick={handleToggleSound} data-id="element-265">
        <video ref={videoRef} className="block w-full h-full object-cover" autoPlay muted playsInline preload="none" onEnded={handleVideoEnded} data-id="element-266">
          <source src={src} type="video/mp4" data-id="element-267" />
        </video>
        {isMuted && <div className="absolute bottom-4 right-4 bg-black/40 text-white px-3 py-1.5 rounded-full text-[10px] font-sans backdrop-blur-sm" data-id="element-268">
            🔊 Tap for sound
          </div>}
      </div>
      <div className="p-5 text-center" data-id="element-269">
        <p className="font-serif italic text-base text-[#3D2B1F] leading-relaxed m-0" data-id="element-270">
          {quote}
        </p>
        <span className="block mt-2 text-[10px] text-[#B76E79] font-bold tracking-[1.5px] uppercase font-sans" data-id="element-271">
          Verified Parent
        </span>
      </div>
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-272">
      <div className="max-w-[900px] mx-auto" data-id="element-273">
        <div className="text-center mb-2.5" data-id="element-274">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-275">
            Real Results
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4 leading-tight text-center" data-id="element-276">
          What B.A.B.Y. Architects Say
        </h2>

        <p className="text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-277">
          Real parents. Real results.
        </p>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-278">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-white rounded-2xl p-7 shadow-md border border-[rgba(183,110,121,0.1)] transition-transform hover:-translate-y-1" data-id="element-279">
              <div className="text-[#C9A96E] text-lg mb-3.5" data-id="element-280">
                {'★'.repeat(testimonial.stars)}
              </div>
              <p className="text-sm text-[#3D2B1F] italic leading-relaxed mb-4" data-id="element-281">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-282">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#B76E79] to-[#C9A96E] flex items-center justify-center text-white font-bold text-base flex-shrink-0" data-id="element-283">
                  {testimonial.initials}
                </div>
                <div data-id="element-284">
                  <div className="text-sm font-bold text-[#3D2B1F]" data-id="element-285">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-gray-400 font-sans" data-id="element-286">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Video Testimonials */}
        <div className="grid md:grid-cols-2 gap-6 mt-10 max-w-[840px] mx-auto" data-id="element-287">
          <VideoCard src="https://cdn.shopify.com/videos/c/o/v/63018b10745840f186a10c50d40b0156.mp4" quote={`"I found this really early... and it just made everything easier."`} data-id="element-288" />
          <VideoCard src="https://cdn.shopify.com/videos/c/o/v/09c067513c4f4548ab4178a4a320aa5f.mp4" quote={`"I didn't expect this to make a difference... but it just works."`} data-id="element-289" />
        </div>
      </div>
    </section>;
}